import React, { Component } from "react";
import axios from "axios";
import QAndA from "./QAndA";
import { Container, Row, Col, Media } from "reactstrap";
import viewHeaderImage from "../images/viewHeader.png";
import { joinCss } from "../helpers/utils";

import appClasses from "../App.module.scss";
import classes from "./FAQEn.module.scss";

class FAQEn extends Component {
  state = {
    faq: null,
    viewName: "FAQ"
  };

  componentDidMount() {
    axios.get("/api/faq?lang=en").then(res => {
      this.setState({
        faq: res.data
      });
    });
  }

  render() {
    let faqHtml = "";
    if (this.state.faq && this.state.faq.length > 0) {
      faqHtml = (
        <div className="mb-5">
          {this.state.faq.map(element => (
            <QAndA data={element} key={element.Id} />
          ))}
        </div>
      );
    } else {
      faqHtml = <div className="mb-5">Data will load soon...</div>;
    }
    return (
      <Container className={classes.faqEn}>
        <Row>
          <Col sm="12" className="px-0">
            <Media heading>
              <Media
                src={viewHeaderImage}
                alt="תמונה כללית"
                className={appClasses.headerImage}
              />
            </Media>
            <div
              className={joinCss(
                classes.headerTitleLeft,
                appClasses["left-align-div"],
                "mt-2",
                "mr-5"
              )}
            >
              <div>{this.state.viewName}</div>
            </div>
          </Col>
        </Row>
        <div class="mt-5">{faqHtml}</div>
      </Container>
    );
  }
}

export default FAQEn;
